var moduleName = 'services.eCrypt';

const $inject = ["$http"];

/**
 * Load the eCrypt encryption methods
 */
class eCryptService {

    /**
     * @constructor
     * @param $http
     */
    constructor($http) {
        this.http = $http;
        this.loading = false;
    }

    /**
     * Load the eCrypt service if it is not already loading/ready
     */
    load() {
        if(!this.loading && !this.isReady()) {
            angular.element('<script src="https://secure.ewaypayments.com/scripts/eCrypt.js"></script>').appendTo(document.body);
        }
    }

    /**
     * Check whether the eCrypt library has been loaded
     * @returns {boolean}
     */
    isReady() {
        return (typeof eCrypt != 'undefined');
    }

}

/**
 * Dependencies
 */
eCryptService.$inject = $inject;


/**
 * Add to angular and make available
 */
export default angular.module(moduleName, [])
    .service('eCryptService', eCryptService)
    .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/eCrypt.service.js
 **/